
import React, { Component } from 'react'

import Colors from 'material-ui/styles/colors'
import TextField from 'material-ui/TextField'
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Divider from 'material-ui/Divider'
import {List, ListItem} from 'material-ui/List'

import StarsRating from 'components/StarsRating'
import Checkbox from 'material-ui/Checkbox'
import { sort, sortSev, getByType, beautifyPhone, getCors } from 'utils/stuff'



export default class ContactsBlock extends Component{
	constructor(props){
		super(props)
		this.state ={
			phoneNumber: {
				value: (props.repairman)? props.repairman.phoneNumber : undefined
			  , selectionStart: undefined
			}
		  , cellNumber: {
				value: (props.repairman)? props.repairman.cellNumber : undefined
			  , selectionStart: undefined
			}
		  , homeNumber: {
				value: (props.repairman)? props.repairman.homeNumber : undefined
			  , selectionStart: undefined
			}
		  , faxNumber:  {
				value: (props.repairman)? props.repairman.faxNumber : undefined
			  , selectionStart: undefined
			}
		  , editing: ""
		}
	}
	componentWillUpdate(){
		if(this.props.repairman && (typeof this.state.phoneNumber.value != "string" || typeof this.state.cellNumber.value != "string")){
			this.setState({
				phoneNumber: {
					value: this.props.repairman.phoneNumber
				  , selectionStart: this.props.repairman.phoneNumber.length
				}
			  , cellNumber: {
					value: this.props.repairman.cellNumber
				  , selectionStart: this.props.repairman.cellNumber.length
				}
			  , homeNumber: {
					value: this.props.repairman.homeNumber
				  , selectionStart: undefined
				}
			  , faxNumber:  {
					value: this.props.repairman.faxNumber
				  , selectionStart: undefined
				}
			})
		}
	}
	render(){
		return(
			<div>
				<header
					style={{
						width: "100%"
					  , height: "60px"
					  , top: "0"
					  , zIndex: "5555"
					  , backgroundColor: "#00ACC1"
					  , position: "fixed"
					  , lineHeight: "60px"
					}}
					className="action-bar"
				>
					<div
						style={{
							width: "inherit"
						  , height: "inherit"
						  , textAlign: "center"
						}}
					>
						<span
							style={{
								display: "inline-block"
							  , position: "absolute"
							  , left : "4px"
							}}
							onClick={()=> this.props.setState("")}
						>
							<svg
								width="16px"
								height="16px"
								viewBox="0 0 17 17"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{
									verticalAlign: "middle"
								  , marginLeft: "12px"
								  , cursor: "pointer"
								  , paddingBottom: "3px"
								  , marginRight: "5px"
								}}
							>
								<title>Group</title>
								<defs></defs>
								<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
									<g id="Group" transform="translate(1.000000, 1.000000)" stroke="#909090" strokeWidth="2">
										<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										<path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
									</g>
								</g>
							</svg>
							Contacts
						</span>
					</div>
				</header>
				<div
					style={{
						padding: "50px 10px 20px 10px"
					}}
				>
					<div>
						<div style={{marginTop: '0px'}}>
							<div style={{
									width: (typeof global.md.phone() != 'string')? "calc(50% - 24px)" : "100%"
								  , display: (typeof global.md.phone() != 'string')? "inline-block" : "block"
								  , marginLeft: (typeof global.md.phone() != 'string')? "20px" : "0"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.cellNumber.value}
									floatingLabelText="Mob"
									ref={`cellNumber-${this.props.repairman._id}`}
									key={`${this.props.repairman._id}-pn`}
									inputStyle={{fontSize: "18"}}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										if(evt.target.value.replace(/\D/g, '').length >= this.state.cellNumber.value.replace(/\D/g, '').length){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											cellNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`cellNumber-${this.props.repairman._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.repairman._id
											  , cellNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.repairman.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change phone'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.repairman.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change phone'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
										: false
									}
								/>
							</div>
							<div style={{
									width: (typeof global.md.phone() != 'string')? 'calc(50% - 16px)' : "100%"
								  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
								  , float: (typeof global.md.phone() != 'string')? "right": "none"
								  , marginTop: (typeof global.md.phone() != 'string')? "auto": "-15pt"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.phoneNumber.value}
									floatingLabelText="Work"
									key={`${this.props.repairman._id}-cn`}
									inputStyle={{fontSize: "18"}}
									ref={`phoneNumber-${this.props.repairman._id}`}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										if(evt.target.value.replace(/\D/g, '').length >= this.state.phoneNumber.value.replace(/\D/g, '').length){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											phoneNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`phoneNumber-${this.props.repairman._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.repairman._id
											  , phoneNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.repairman.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change cell'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.repairman.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change cell'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
											: false
									}
								/>
							</div>
							<div style={{
									width: (typeof global.md.phone() != 'string')? 'calc(50% - 16px)' : "100%"
								  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
								  , float: (typeof global.md.phone() != 'string')? "right": "none"
								  , marginTop: (typeof global.md.phone() != 'string')? "auto": "-15pt"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.homeNumber.value}
									floatingLabelText="Home"
									key={`${this.props.repairman._id}-cn`}
									inputStyle={{fontSize: "18"}}
									ref={`homeNumber-${this.props.repairman._id}`}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										let lengthVal = (this.state.homeNumber && this.state.homeNumber.value)? this.state.homeNumber.value.replace(/\D/g, '').length : 0
										if(evt.target.value.replace(/\D/g, '').length >= lengthVal){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											homeNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`homeNumber-${this.props.repairman._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.repairman._id
											  , homeNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.repairman.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change number'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.repairman.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change number'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
											: false
									}
								/>
							</div>
							<div style={{
									width: (typeof global.md.phone() != 'string')? 'calc(50% - 16px)' : "100%"
								  , display: (typeof global.md.phone() != 'string')? 'inline-block' : "block"
								  , float: (typeof global.md.phone() != 'string')? "right": "none"
								  , marginTop: (typeof global.md.phone() != 'string')? "auto": "-15pt"
								}}
							>
								<TextField
									style={{width: "calc(100% - 40px)"}}
									value={this.state.faxNumber.value}
									floatingLabelText="Fax"
									key={`${this.props.repairman._id}-cn`}
									inputStyle={{fontSize: "18"}}
									ref={`faxNumber-${this.props.repairman._id}`}
									onChange={(evt) => {
										let carret = evt.currentTarget.selectionStart
										let specCharIndxs = [1, 4, 5, 6, 9]
										let lengthVal = (this.state.faxNumber && this.state.faxNumber.value)? this.state.faxNumber.value.replace(/\D/g, '').length : 0
										if(evt.target.value.replace(/\D/g, '').length >= lengthVal){
											if(!!~specCharIndxs.indexOf(carret)) carret = carret + 1
											if(carret == 4) carret = carret + 1
											if(carret == 5) carret = carret + 1
										}
										this.setState({
											faxNumber:
												{
													value: beautifyPhone(evt.target.value)
												}
											}
										  , function(){
												this.refs[`faxNumber-${this.props.repairman._id}`]._getInputNode().setSelectionRange(carret, carret);
											}
										)
									}}
									onBlur={(evt)=>
										(evt.target.value.length)?
											this.props.docUpd({
												_id: this.props.repairman._id
											  , faxNumber: beautifyPhone(evt.target.value)
											  , comments: (!this.props.repairman.comments)?
													[{
														userID: this.props.login.userID
													  , auto: true, body: 'Change fax'
													  , date: new Date().valueOf()
													  , value: beautifyPhone(evt.target.value)
													}]
													: [
														...this.props.repairman.comments
													  , {
															userID: this.props.login.userID
														  , auto: true, body: 'Change fax'
														  , date: new Date().valueOf()
														  , value: beautifyPhone(evt.target.value)
														}
													]
											})
											: false
									}
								/>
							</div>
						</div>
						<div style={{
								marginTop: '-20px'
							  , width: (typeof global.md.phone() != 'string')? 'calc(50% - 40px)': "100%"
							  , float: (typeof global.md.phone() != 'string')? "left" : "none"
							  , marginLeft: (typeof global.md.phone() != 'string')? "40px" : "0"
							}}
						>
							<TextField
								style={{width: "calc(100% - 42px)"}}
								defaultValue={this.props.repairman.email}
								key={`${this.props.repairman._id}-emal`}
								floatingLabelText="E-mail"
								inputStyle={{fontSize: "18"}}
								onBlur={(evt)=>
									(evt.target.value.length)?
										this.props.docUpd({
											_id: this.props.repairman._id
											, email: evt.target.value
											, comments: (!this.props.repairman.comments)?
												  [{
													  userID: this.props.login.userID
													, auto: true, body: 'Change e-mail'
													, date: new Date().valueOf()
													, value: evt.target.value
												  }]
												  : [
													  ...this.props.repairman.comments
													, {
														  userID: this.props.login.userID
														, auto: true, body: 'Change e-mail'
														, date: new Date().valueOf()
														, value: evt.target.value
													  }
												  ]
										})
										: false
								}
							/>

						</div>
						<div style={{
								marginTop: '-20px'
							  , width: (typeof global.md.phone() != 'string')? 'calc(50% - 40px)' : "100%"
							  , float: (typeof global.md.phone() != 'string')? "right" : "none"
							  , marginRight: "20px"
							}}
						>
							<TextField
								style={{width: "calc(100% - 40px)"}}
								defaultValue={this.props.repairman.web}
								key={`${this.props.repairman._id}-web`}
								floatingLabelText="Web"
								inputStyle={{fontSize: "18"}}
								onBlur={(evt)=>
									(evt.target.value.length)?
										this.props.docUpd({
											_id: this.props.repairman._id
										  , web: evt.target.value
										  , comments: (!this.props.repairman.comments)?
												[{
													userID: this.props.login.userID
												  , auto: true, body: 'Change web address'
												  , date: new Date().valueOf()
												  , value: evt.target.value
												}]
												: [
													...this.props.repairman.comments
												  , {
														userID: this.props.login.userID
													  , auto: true, body: 'Change web address'
													  , date: new Date().valueOf()
													  , value: evt.target.value
													}
												]
										})
										: false
								}
							/>

						</div>
						<div style={{marginTop: (typeof global.md.phone() != 'string')? '0px' : "-18pt", marginLeft: (typeof global.md.phone() != 'string')? "36px" : "0"}}>
							<div>
								<TextField
									style={{width: "calc(100% - 73px)"}}
									defaultValue={(this.props.repairman.address)? this.props.repairman.address : ''}
									floatingLabelText="Address"
									multiLine={true}
									rows={2}
									key={`${this.props.repairman._id}-str`}
									inputStyle={{fontSize: "18"}}
									onBlur={(evt)=>{
										if(evt.target.value.length){
												getCors(
													evt.target.value,
													(response) => {
														debugger
														this.props.docUpd({
															_id: this.props.repairman._id
														 , cors: response
														})
													}
												)
												this.props.docUpd({
													_id: this.props.repairman._id
												  , address: evt.target.value
												  , comments: (!this.props.repairman.comments)?
														[{
															userID: this.props.login.userID
														  , auto: true, body: 'Change address'
														  , date: new Date().valueOf()
														  , value: evt.target.value
														}]
														: [
															...this.props.repairman.comments
														  , {
																userID: this.props.login.userID
															  , auto: true, body: 'Change address'
															  , date: new Date().valueOf()
															  , value: evt.target.value
															}
														]
												})
											}
										}
									}
								/>
							</div>
						</div>
						<div style={{marginTop: (typeof global.md.phone() != 'string')? '0px' : "-18pt", marginLeft: (typeof global.md.phone() != 'string')? "36px" : "0"}}>
							<div>
								<TextField
									style={{width: "calc(100% - 73px)"}}
									defaultValue={(this.props.repairman.accountNumber)? this.props.repairman.accountNumber : ''}
									floatingLabelText="Account#"
									key={`${this.props.repairman._id}-acct`}
									inputStyle={{fontSize: "18"}}
									onBlur={(evt)=>{
										if(evt.target.value.length){
												this.props.docUpd({
													_id: this.props.repairman._id
												  , accountNumber: evt.target.value
												  , comments: (!this.props.repairman.comments)?
														[{
															userID: this.props.login.userID
														  , auto: true, body: 'Change acct#'
														  , date: new Date().valueOf()
														  , value: evt.target.value
														}]
														: [
															...this.props.repairman.comments
														  , {
																userID: this.props.login.userID
															  , auto: true, body: 'Change acct#'
															  , date: new Date().valueOf()
															  , value: evt.target.value
															}
														]
												})
											}
										}
									}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/repairmanForm/ContactsBlock.js